export default __webpack_public_path__ + "static/media/contract_pt-BR.3e79e741.pdf";